import React from "react";
import ReactDOM from "react-dom/client";
import "grapesjs/dist/css/grapes.min.css";
import "bootstrap";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import DataProvider from "./redux/store";
import { BrowserRouter } from "react-router-dom";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>
  <DataProvider>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </DataProvider>
  // {/* </React.StrictMode> */}
);

reportWebVitals();
